import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import DataContainer from "../../../Utilities/DataContainer";
import EditableTableCell from "../../../Utilities/Forms/EditableTableCell";
import ResidentialUnitsViewModel from "../../ViewModels/DevelopmentDetails/ResidentialUnitsViewModel";

interface IProps {
    residentialUnits: ResidentialUnitsViewModel | null;
    landuse: string;
    subuse: string;
    readOnly: boolean;
}

const fieldMap = [
    { label: "Detached houses", private: "residentialUnits.detachedHousePrivate", nonPrivate: "residentialUnits.detachedHouseNonPrivate", total: "residentialUnits.detachedHouseTotal" },
    { label: "Semi-detached houses", private: "residentialUnits.semiDetachedPrivate", nonPrivate: "residentialUnits.semiDetachedNonPrivate", total: "residentialUnits.semiDetachedTotal" },
    { label: "Terraced houses", private: "residentialUnits.terracedPrivate", nonPrivate: "residentialUnits.terracedNonPrivate", total: "residentialUnits.terracedTotal" },
    { label: "Bungalows", private: "residentialUnits.bungalowPrivate", nonPrivate: "residentialUnits.bungalowNonPrivate", total: "residentialUnits.bungalowTotal" },
    { label: "Flats (in houses)", private: "residentialUnits.flatsInHousesPrivate", nonPrivate: "residentialUnits.flatsInHousesNonPrivate", total: "residentialUnits.flatsInHousesTotal" },
    { label: "Flats (in blocks)", private: "residentialUnits.flatsInBlocksPrivate", nonPrivate: "residentialUnits.flatsInBlocksNonPrivate", total: "residentialUnits.flatsInBlocksTotal" },
    { label: "Town Houses", private: "residentialUnits.townHousePrivate", nonPrivate: "residentialUnits.townHouseNonPrivate", total: "residentialUnits.townHouseTotal" },
    { label: "Other (specify below)", private: "residentialUnits.otherPrivate", nonPrivate: "residentialUnits.otherNonPrivate", total: "residentialUnits.otherTotal" },
];

export default function ResidentialTable({ residentialUnits, landuse, subuse, readOnly }: IProps) {
    return (
        <DataContainer title="Residential Unit Types">
            {((landuse === "03" && !"EHJQ".includes(subuse)) || landuse === "17") && (
                <TableContainer>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell></TableCell>
                                <TableCell>Private</TableCell>
                                <TableCell>Non-Private</TableCell>
                                <TableCell>Total</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {fieldMap.map((row, index) => (
                                <TableRow key={index}>
                                    <TableCell>{row.label}</TableCell>
                                    <EditableTableCell
                                        name={row.private}
                                        value={residentialUnits ? (residentialUnits as any)[row.private.split('.').pop()!] : ''}
                                        readOnly={readOnly}
                                        type="number"
                                    />
                                    <EditableTableCell
                                        name={row.nonPrivate}
                                        value={residentialUnits ? (residentialUnits as any)[row.nonPrivate.split('.').pop()!] : ''}
                                        readOnly={readOnly}
                                        type="number"
                                    />
                                    <EditableTableCell
                                        name={row.total}
                                        value={residentialUnits ? (residentialUnits as any)[row.total.split('.').pop()!] : ''}
                                        readOnly={readOnly}
                                        type="number"
                                    />
                                </TableRow>
                            ))}
                            <EditableTableCell
                                name="residentialUnits.otherResidentialUnitTypeTotal"
                                value={residentialUnits?.otherResidentialUnitTypeTotal ?? ''}
                                readOnly={readOnly}
                            />
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </ DataContainer>
    )
}
